<template>
  <div class="my-currency-detail">
    <Header :title="{name: '余额明细'}"></Header>
    <Empty :empty_type="{name: '暂无余额明细'}" v-if="list.length == 0" style="margin-top:20vw;"></Empty>
    <div class="content">
      <List
        ref="list"
        url="/api/app/integral/details"
        method="get"
        :on-formatter="onFormatter"
        :on-getdata="onGetdata"
        :showText="list.length > 0"
      >
        <div slot="item" class="item" v-for="(item, index) in list" :key="index">
          <img :src="item.showIcon" />
          <div class="info">
            <p class="title">{{item.showTitle}}</p>
            <p class="detail">{{ item.shop_name || item.remark }}</p>
          </div>
          <p class="price">{{item.change_type == 1 ? '+' : '-'}}{{item.change_price | toFixPrice}}</p>
        </div>
      </List>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Empty from "@/components/Empty";
import List from "@/components/List";
export default {
  name: "my-currency-detail",
  components: {
    Header,
    Empty,
    List
  },
  data() {
    return {
      icon_course: require("@/assets/images/icon-msg-course.png"),
      icon_recharge: require("@/assets/images/icon-msg-recharge.png"),
      // icon_vip: require("@/assets/images/icon-msg-vip.png"),
      list: []
    };
  },
  created() {},
  methods: {
    // on event
    onFormatter(rows) {
      rows.forEach(i => {
        if (i.type == 1) {
          i.showIcon = this.icon_recharge;
          i.showTitle = "充值";
        } else if (i.type == 2) {
          i.showIcon = this.icon_course;
          i.showTitle = "消费";
        } else if (i.type == 3) {
          i.showIcon = this.icon_recharge;
          i.showTitle = "退款";
        } else if (i.type == 6) {
          i.showIcon = this.icon_recharge;
          i.showTitle = "平台增加";
        } else if (i.type == 7) {
          i.showIcon = this.icon_course;
          i.showTitle = "平台扣减";
        }
      });
    },
    onGetdata(data) {
      this.list = data;
    }
  }
};
</script>

<style lang="scss" scoped>
.my-currency-detail {
  .header {
    border-bottom: 1px solid #f5f5f5;
  }
  .content {
    padding: 0 30px;
    .item {
      border-bottom: 1px solid #f5f5f5;
      padding: 30px 0;
      display: flex;
      align-items: center;
      position: relative;
      img {
        width: 88px;
        height: 88px;
      }
      .info {
        margin-left: 20px;
        line-height: 50px;
        .title {
          font-size: 30px;
          color: #595959;
        }
        .detail {
          font-size: 26px;
          color: #b7b7b7;
        }
      }
      .price {
        font-size: 30px;
        color: #595959;
        position: absolute;
        top: 50%;
        right: 0px;
        transform: translateY(-50%);
      }
    }
  }
}
</style>
